<template>
	<div class="link-form-grid">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: "link-form-grid",
		props: {},
		data() {
			return {}
		},
		methods: {},
	}
</script>

<style lang="scss">
	.link-form-grid {
		background-color: white;
		padding: 16px 16px 0;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;

		&, & > * {
			box-sizing: border-box;
		}

		.link-form-item {
			margin-bottom: 28px;
			width: 33.33%;
			display: inline-block;

			& > div {
				vertical-align: top;
			}

			.link-form-item-label {
				width: 33.33%;
				display: inline-block;
				text-align: right;
				font-size: 12px;
				box-sizing: border-box;
				line-height: 2em;
				color: $color-normal-content;
			}

			.link-form-item-content {
				width: 66.66%;
				white-space: pre;
				display: inline-flex;
				align-items: center;

				.pl-time, .pl-date, .link-select, .link-input, .pl-popover, .pl-popover-reference, .link-textarea {
					&:not(.link-input-number) {
						flex: 1;

						.link-input {
							width: 100% !important;
						}
					}
				}

				& > span {
					font-size: 12px;
					vertical-align: middle;
					margin-left: 3px;
					color: $color-normal-content;
				}
			}

			.link-form-item-external {
				width: 100%;

				& > .link-form-item {
					width: 100%;
					margin-top: 28px;
				}
			}
		}
	}

	@include themeify {
		.link-form-grid {
			.link-form-item-label-required-tag {
				color: pl-var(color-error);
			}
		}
	}
</style>